<template>
  <div class="modules">
    <div class="modules-list">
      <DefaultCard
        v-for="(item, i) in modules"
        :key="i"
        :image-path="item.img"
        :card-text="item.name"
        modules
        @click-card="goToEdit(item.slug, item.isModal)"
      />
    </div>
    <HistoryChangeModules v-if="false"/>
  </div>
</template>

<script>
import { useStore } from 'vuex'

import DefaultCard from '@/components/blocks/DefaultCard'
import HistoryChangeModules from '@/components/elements/HistoryChangeModules'

import router from '@/router'

export default {
  name: 'ModulesList',
  components: {
    DefaultCard,
    HistoryChangeModules
  },
  props: {
  },
  setup () {
    const store = useStore()

    const modules = [
      {
        id: 1,
        name: 'Баннер',
        img: require('@/assets/images/png/modules-list/image_track.png'),
        slug: 'banner',
        isModal: ''
      },
      // {
      //   id: 2,
      //   name: 'Направления деятельности',
      //   img: require('@/assets/images/png/modules-list/image_activity.png'),
      //   slug: 'activity',
      //   isModal: ''
      // },
      {
        id: 3,
        name: 'Достижения',
        img: require('@/assets/images/png/modules-list/image_achievements.png'),
        slug: 'achievements',
        isModal: ''
      },
      {
        id: 4,
        name: 'Регионы',
        img: require('@/assets/images/png/modules-list/image_regions.png'),
        slug: 'regions',
        isModal: ''
      }
      // {
      //   id: 5,
      //   name: 'Как с нами работать',
      //   img: require('@/assets/images/png/modules-list/image_cooperation.png'),
      //   slug: 'cooperation',
      //   isModal: ''
      // },
      // {
      //   id: 6,
      //   name: 'СМИ о нас',
      //   img: require('@/assets/images/png/modules-list/image_media.png'),
      //   slug: 'media',
      //   isModal: ''
      // },
      // {
      //   id: 7,
      //   name: 'Материалы',
      //   img: require('@/assets/images/png/modules-list/image_materials.png'),
      //   slug: 'materials',
      //   isModal: ''
      // },
      // {
      //   id: 8,
      //   name: 'Подвал',
      //   img: require('@/assets/images/png/modules-list/image_footer.png'),
      //   slug: 'footer',
      //   isModal: ''
      // }
    ]

    const goToEdit = (val, modal) => {
      if (modal === '') {
        router.push(`/modules/editor/${val}`)
      } else {
        if (modal === 'achievment') {
          store.commit('SetShowAchievementsEditor', true)
        } else {
          store.commit('SetM_ShowRegionsEditorView', true)
        }
      }
    }
    return {
      modules,
      goToEdit
    }
  }
}
</script>

<style lang="scss" scoped>
.modules {
  &-list {
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
    margin-bottom: 60px;
  }

  &-history {
    position: fixed;
    bottom: 40px;
    right: 135px;
  }
}
</style>
